import { RouterStateSnapshot, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { RouteGuardService } from "./core/services/route-guard.service";

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    canActivate: [
      (_: any, state: RouterStateSnapshot) => inject(RouteGuardService).requireLogin(state)
    ],
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'login',
    canActivate: [
      () => inject(RouteGuardService).requireUnauthenticated()
    ],
    loadComponent: () => import('./core/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'onboarding',
    canActivate: [
      () => inject(RouteGuardService).canActivateOnboarding()
    ],
    loadComponent: () => import('./core/onboarding/onboarding-page/onboarding-page.component').then(m => m.OnboardingPageComponent)
  },
  {
    path: 'blog',
    canActivate: [
      (_: any, state: RouterStateSnapshot) => inject(RouteGuardService).requireLogin(state)
    ],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/blog/blog-page/blog-page.component').then(m => m.BlogPageComponent)
      },
      {
        path: ':blogPostId',
        loadComponent: () => import('./features/blog/blog-detail-page/blog-detail-page.component').then(m => m.BlogDetailPageComponent)
      }
    ]
  },
  {
    path: 'ranking',
    canActivate: [
      (_: any, state: RouterStateSnapshot) => inject(RouteGuardService).requireLogin(state)
    ],
    loadComponent: () => import('./features/ranking/ranking-page/ranking-page.component').then(m => m.RankingPageComponent)
  },
  {
    path: 'questionnaire/:questionnaireId',
    canActivate: [
      (_: any, state: RouterStateSnapshot) => inject(RouteGuardService).requireLogin(state)
    ],
    loadComponent: () => import('./features/questionnaire/questionnaire-page/questionnaire-page.component').then(m => m.QuestionnairePageComponent)
  },
  {
    path: 'archive',
    canActivate: [
      (_: any, state: RouterStateSnapshot) => inject(RouteGuardService).requireLogin(state)
    ],
    loadComponent: () => import('./features/questionnaire/questionnaire-archive-page/questionnaire-archive-page.component').then(m => m.QuestionnaireArchivePageComponent)
  },
  {
    path: 'about',
    loadComponent: () => import('./features/about/about.component').then(m => m.AboutComponent)
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
